import {useState, useEffect} from "react";
import EditLocation from "./editLocation.js";
import "../css/location.css";
import LocationCard from "./locationCard.js";
import {BASE_URL} from "../constants";
import { useLanguage } from "../components/Language.js";

function ShowLocations({onClose}) {

    const [locationData, setLocationData] = useState([]);

    // const user = JSON.parse(sessionStorage.getItem("USER"));
    let user = (sessionStorage.getItem("USER") === null ? null : JSON.parse(sessionStorage.getItem("USER")));

    if (user !== null){
        console.log("admin status: ",user.admin);
    }


    useEffect(() => {
        fetchLocationData();
    }, []);

    const {language} = useLanguage();

    const translations = {
        en: {
            noLocationsAvailable: "No locations available",
            close: "Close",
            locations: "Locations: "
        },

        gd: {
            noLocationsAvailable: "Chan eil àiteachan rim faotainn",
            close: "Dùin",
            locations: "Àiteachan: ",
        },
    };



    const fetchLocationData = async () => {

        try {
            const response = await fetch(`${BASE_URL}/api/get_location_data/`);
            if (response.ok) {
                const data = await response.json();
                setLocationData(data);

            } else {
                console.error('Failed to fetch user reports');
            }
        } catch (error) {
            console.error('Error fetching user reports:', error);
        }
    };

    return(

        <div>
        
            <div className="location-header">
                <h2> {translations[language].locations} </h2>
                <button className= "close-x" onClick={onClose}>&times;</button> 
            </div>

            {locationData.length > 0 ? (
                locationData.map((location, index) => (

                    <LocationCard
                        index = {index}
                        location = {location}
                        user = {user}
                        fetchLocationData = {fetchLocationData}
                    />
                ))
            ) : (
                <p>{translations[language].noLocationsAvailable}</p>
            )}

            <button onClick={onClose} className="GCPillbutton" >{translations[language].close}</button>


        </div>
 
    )
};

export default ShowLocations;